import React from 'react'

const Description = (props: any) => {

  const { textColor, textAlign, content, subContent } = props;

  return (
    <p style={{ color: textColor, textAlign: textAlign }}>
      {content}<br/>
      {subContent}
    </p>
  )
};

export default Description